var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Master',[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }